import React from "react";
import LigCustomModal from "../../../assets/components/LigCustomModal";
import Classes from "./styles/style.module.css";

const LigIntro = ({ show, closeHander }) => {
  const dialogContent = (
    <div className={Classes.ligModalContainer}>
      <h4 className="mb-4">معرفی لیگ قرآنی</h4>
      <div className="d-flex" >
        <p className="mb-3 text-justify">
        به لیگ قرآنی خوش اومدی.<br/>
        اینجا قراره که با هم کلی با قرآن خوش بگذرونیم و در این شش هفته مقداری با قرآن رفیق بشیم.<br/>
        توی این لیگ هم چالش داریم که باید انجامش بدی و هم کلی مطلب شگفت انگیز قراره از قرآن یاد بگیری.<br/>
        توی این مدت شش هفته یه دوست صمیمی کنارت هست که در تک تک چالش ها باهات همراهی می کنی ما اسمش را گذاشتیم پشتیبان! از دیدار حضوری بگیر تا پیامک و چت؛ می تونی باهاش در ارتباط باشی و اگر سوالی یا ابهامی داشتی ازش بپرسی.<br/>
        ما توی لیگ قرآنی نمی خواهیم زیاد ازت وقت بگیریم، فقط این نکته رو بدون که روزهای یک شنبه و چهارشنبه هر هفته چالش های متنوعی داریم که هر کدوم رو به وقتش متوجه میشی.<br/>
        اگه گفتی کجا می تونی این چالش ها رو ببینی و حلش کنی؟<br/>
        جوابش خیلی سادست، فقط کافیه وارد اپلیکیشن راه بهشت (Rahebehesht.com) بشی و بعدش بری توی قسمت لیگ قرآنی، وقتی بزنی روی دکمه شروع چالش با یه جزیره خفن روبرو میشی که تموم این چالش ها توی این جزیره خوشگل پنهان شده و باید به وقتش دونه به دونشون رو کشف کنی و حل کنی.<br/>
        این رو هم در نظر داشته باش که بابت تلاش هایی که می کنی کلی جایزه هیجان انگیز در انتظارته که اگه پایه باشی می تونی حتما جایزه های خوبی بگیری.<br/>
        راستی تا یادمون نرفته حتما از پدر یا مادرت پیگیری کن تا بسته ویژه ای که برات آماده شده رو از واحد امور فرهنگی فولاد مبارکه تحویل بگیرند که یه سری از چالش ها توی اون بسته است.<br/>
        اگه احیانا باز هم سوالی داشتی، می تونی از پشتیبانت بپرسی و ابهاماتت را رفع کنی.<br/>
        قراره کلی تجربه جدید کسب کنی پس پیش بسوی لیگ قرآنی.
        </p>
      </div>
      <div className="my-4 text-center">
        <button className="purplebutton" onClick={closeHander}>
          بزن بریم...
        </button>
      </div>
    </div>
  );
  return (
    <LigCustomModal
      open={show}
      closeHandler={closeHander}
      dialogContent={dialogContent}
      scrollable={true}
    />
  );
};

export default LigIntro;
